@let request = $request();

@if (request.products?.length) {
  @let devicesInstallQuality = $devicesInstallQuality() || {};
  <div
    class="grid grid-cols-[40px_1fr_52.5px] row-start-auto auto-rows-[minmax(auto,52.5px)] gap-1 items-start content-start overflow-y-auto max-h-[203px]"
  >
    @for (requestProduct of request.products; track requestProduct.id) {
      @let productId = requestProduct.requestProductId.id;
      @let deviceModelId = requestProduct.requestProductId.deviceModel;
      @let canAddDevice =
        productIsDevice(productId) &&
        !request.isCompleted &&
        (permissionService.canLogistAddDevices$ | async);
      <section class="flex items-center h-full">
        <x-request-product-icon
          [requestProduct]="requestProduct"
          [requestDevices]="request.devices"
          [withCounter]="false"
          [iconSize]="RequestProductIconSize.Md"
        ></x-request-product-icon>
      </section>
      <section class="flex items-center h-full">
        <div class="x-text-03 font-extrabold">
          <span
            [tuiHint]="
              requestProduct.completed && !requestProduct.isClosedForcingly
                ? ('request_form.goods.hint_completed_successfully' | translate)
                : requestProduct.isClosedForcingly
                  ? ('request_form.goods.hint_closed_forcingly' | translate)
                  : ''
            "
            tuiHintAppearance="dark"
            [ngClass]="{
              'x-text-green':
                requestProduct.completed && !requestProduct.isClosedForcingly,
              'x-text-red': requestProduct.isClosedForcingly,
            }"
          >
            {{
              requestProduct.requestProductId
                | entityTranslate: 'request_products'
            }}
          </span>
          <span tuiBadge class="mx-1 font-medium! mb-1" size="s">{{
            requestProduct.amount
          }}</span>
        </div>
      </section>
      <div class="flex self-center">
        @if (canAddDevice) {
          <x-icon-button
            iconName="@tui.plus"
            [iconSize]="16"
            class="self-end"
            [clickFunction]="toggleAddDeviceForm.bind(this, productId)"
          />
        }
      </div>
      @let addProductFormGroup = getAddProductDeviceForm(productId);

      @let devicesList = getDevicesByModelId(deviceModelId);
      @if (devicesList.length) {
        @for (device of devicesList; track device.id) {
          @let deviceInstallQuality =
            devicesInstallQuality?.[device.deviceHash];
          @let tamperState = getTamperState(device.deviceHash);
          <section class="grid col-span-2 col-start-2">
            <p class="x-text-dark-main flex items-center font-semibold">
              <span (click)="scrollToDevicesBlock()" class="cursor-pointer">
                {{ device.name }}
              </span>
              @if (permissionService.canViewInstallQuality$ | async) {
                @switch (
                  deviceInstallQuality?.lastCheck?.installation_quality_score
                ) {
                  @case ('bad') {
                    <span
                      tuiBadge
                      tuiStatus
                      size="s"
                      appearance="negative"
                      class="ml-1"
                      >{{
                        'request_form.devices.device.install_quality.bad_short'
                          | translate
                      }}</span
                    >
                  }
                  @case ('gps_good') {
                    <span
                      tuiBadge
                      tuiStatus
                      size="s"
                      appearance="positive"
                      class="ml-1"
                      >{{
                        'request_form.devices.device.install_quality.gps_good_short'
                          | translate
                      }}</span
                    >
                  }
                  @case ('gsm_or_wifi_good') {
                    <span
                      tuiBadge
                      tuiStatus
                      size="s"
                      appearance="positive"
                      class="ml-1"
                      >{{
                        'request_form.devices.device.install_quality.gsm_or_wifi_good_short'
                          | translate
                      }}</span
                    >
                  }
                  @case (null) {
                    @if (deviceInstallQuality?.lastRequest?.finished) {
                      <span
                        tuiBadge
                        tuiStatus
                        size="s"
                        appearance="negative"
                        class="ml-1"
                        >{{
                          'request_form.devices.device.install_quality.timed_out'
                            | translate
                        }}</span
                      >
                    } @else {
                      <span
                        tuiBadge
                        tuiStatus
                        size="s"
                        appearance="neutral"
                        class="ml-1"
                        >{{
                          'request_form.devices.device.install_quality.never_checked_short'
                            | translate
                        }}</span
                      >
                    }
                  }
                }

                @if (
                  tamperState.loadState === 'loaded' &&
                  tamperState.status?.isMounted === true
                ) {
                  <span
                    tuiBadge
                    tuiStatus
                    size="s"
                    appearance="positive"
                    class="ml-1"
                    >{{
                      'request_form.devices.device.tamper.mounted' | translate
                    }}</span
                  >
                } @else if (
                  tamperState.loadState === 'loaded' &&
                  tamperState.status?.isMounted === false
                ) {
                  <span
                    tuiBadge
                    tuiStatus
                    size="s"
                    appearance="negative"
                    class="ml-1"
                    >{{
                      'request_form.devices.device.tamper.not_mounted'
                        | translate
                    }}</span
                  >
                } @else if (
                  tamperState.loadState === 'error' ||
                  tamperState.loadState === 'not_found' ||
                  (tamperState.loadState === 'loaded' &&
                    (tamperState.status === null ||
                      tamperState.status.isMounted === null))
                ) {
                  <span
                    tuiBadge
                    tuiStatus
                    size="s"
                    appearance="warning"
                    class="ml-1"
                    >{{
                      'request_form.devices.device.tamper.not_mounted_unknown'
                        | translate
                    }}</span
                  >
                }
              }
            </p>
          </section>
        }
      }
      @if (deviceAddForm[productId] && addProductFormGroup) {
        <section
          [formGroup]="addProductFormGroup"
          class="grid col-span-3 grid-cols-[1fr_52.5px] mb-1 items-center"
        >
          <div>
            <tui-textfield
              class="me-2"
              tuiTextfieldSize="s"
              [tuiTextfieldCleaner]="true"
              iconStart="@tui.plus"
            >
              <!-- Поле размера s: метка не помещается внутрь и ложится на рамку — как в v3, текст плейсхолдером -->
              <input
                [placeholder]="
                  'request_form.summary.enter_device_number' | translate
                "
                [formControlName]="'sim1'"
                inputmode="numeric"
                [maskito]="simMask"
                [tuiUnmaskHandler]="unmaskSim"
                tuiInput
                class="text-[15px]/[24px]! font-extrabold!"
                inputmode="numeric"
              />
            </tui-textfield>
            <tui-error [formControlName]="'sim1'"></tui-error>
          </div>
          <tui-icon
            icon="@tui.check"
            class="rounded-full text-white h-[42px]! w-[42px]! justify-self-center self-baseline cursor-pointer text-base"
            [ngClass]="
              addProductFormGroup.valid
                ? 'x-bg-green cursor-pointer'
                : 'x-white-secondary cursor-not-allowed'
            "
            (click)="performAddNewDeviceToRequest(productId)"
          ></tui-icon>
        </section>
      }
    }
  </div>
}

@if (request.productPresetSnapshot) {
  <div>
    <div tuiNotification size="m" appearance="info">
      {{ 'request_form.goods.preset_applied' | translate }}
      {{ request.productPresetSnapshot.name }}
    </div>
  </div>
}

@if (!request.products?.length) {
  <div class="text-center">
    <x-empty-block [title]="'request_form.goods.empty_list' | translate" />
  </div>
}
